import { CostCenter } from "@finway-group/shared/lib/models"

/**
 * Groups the given cost center by parents. If no parent is available, or the parent is not
 * in the given list (e.g. because of permission restrictions), then leave as an individual
 * cost center.
 */
export const groupCostCentersByParent = (costCenters: CostCenter[]) =>
    costCenters
        .filter((costCenter: CostCenter) => !costCenter.parentCostCenter || !costCenters.find((otherCostCenter: CostCenter) => otherCostCenter._id === costCenter.parentCostCenter))
        .map((costCenter: any) =>
            costCenter.subCostCenters?.length > 0
                ? {
                      ...costCenter,
                      children: findSubCostCentersByIds(
                          costCenter.subCostCenters,
                          costCenters.filter((costCenter: CostCenter) => costCenter.parentCostCenter)
                      ),
                  }
                : costCenter
        )

const findSubCostCentersByIds = (subCostCenterIds: string[], costCenters: CostCenter[]): any =>
    subCostCenterIds
        .map((costCenterId: string) => costCenters.find((costCenter: CostCenter) => costCenter._id === costCenterId))
        .filter((costCenter: CostCenter) => costCenter !== undefined)

export const findSearchResultParentCostCenters = (costCenters: CostCenter[]): any[] => {
    let parentCostCenterIds: string[] = []
    for (const costCenter of costCenters) {
        const isParentSearchResult = costCenters.find((cc: CostCenter) => cc._id === costCenter.parentCostCenter)
        const isParentAlreadyMatched = costCenter.parentCostCenter && parentCostCenterIds.includes(costCenter.parentCostCenter)

        if (costCenter.parentCostCenter && !isParentSearchResult && !isParentAlreadyMatched) {
            parentCostCenterIds.push(costCenter.parentCostCenter)
        }
    }

    return parentCostCenterIds
}

export const isParentCostCenterAvailable = (costCenter: CostCenter, costCenters: CostCenter[]) =>
    costCenter.parentCostCenter && costCenters.find((otherCostCenter: CostCenter) => otherCostCenter._id === costCenter.parentCostCenter)

export const getCostCenterLabel = (costCenter: CostCenter, shouldShowId: boolean) => (shouldShowId ? `ID ${costCenter.id} - ${costCenter.name}` : costCenter.name)
